import { DeviceProxyApi as DeviceProxyApiClient } from '@solink/vd-data-layer/api-clients/device-proxy';
import { AuthenticatedRequestor } from '@solink/vd-data-layer/api-clients/shared/AuthenticatedRequestor';
import settings from '@solinkcorp/settings';
import AuthService from 'models/AuthService';
import * as constants from 'vd-constants';

export default function DeviceProxyApi() {
  const authToken = AuthService.authToken;
  return new DeviceProxyApiClient(
    // MUST NOT Include the custom solink header
    // AWS API Gateway will block the request otherwise
    new AuthenticatedRequestor(
      settings.device_proxy_url,
      constants.REQUEST_TIMEOUT,
      authToken,
      false,
    ),
  );
}
